// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YxQdiUcWUVMqX4oOLhVj{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100%;display:flex}.YxQdiUcWUVMqX4oOLhVj .Rb9BevGm96ARQs_6dJpt{text-align:center}.L3YWtQfAQtMQTn07iMcq{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YxQdiUcWUVMqX4oOLhVj`,
	"subtitle": `Rb9BevGm96ARQs_6dJpt`,
	"successWrap": `L3YWtQfAQtMQTn07iMcq`
};
export default ___CSS_LOADER_EXPORT___;
